import { render, staticRenderFns } from "./receivingposting_partialconfirm.vue?vue&type=template&id=647c0738"
import script from "./receivingposting_partialconfirm.vue?vue&type=script&lang=js"
export * from "./receivingposting_partialconfirm.vue?vue&type=script&lang=js"
import style0 from "./receivingposting_partialconfirm.vue?vue&type=style&index=0&id=647c0738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports